// import SparkMD5 from 'spark-md5'
import axios from 'axios'
import request from '@/utils/request'
/**
 *
 * @param {*} file 上传的文件对象
 * @param {*} uploadMode 上传文件模式
 * PRIVATE 私有模式，将返回bucket与objectName，业务方需要使用oss sdk进行下载
 * GRANT_READ_WITH_EXPIRATION：限时授权模式，在有效期内可以读取文件
 * GRANT_READ 长期授权模式，可以长期使用
 * VPC_READ VPC内部模式，可以在vpc内部直接使用
 * PUBLIC_READ 公开模式，可以在公网直接读取
 * PUBLIC_READ_WITH_CDN CDN模式，将文件推送至公网CDN
 * type 文件上传接口：image,
 * type Excel上传接口：excel,  zip包上传接口：zip
 */
// function doUploadFile(
//   file,
//   group = 'test_group',
//   module = 'test_module',
//   uploadMode = 'PUBLIC_READ_WITH_CDN',
//   type,
// ) {
//   type = type || 'file'
//   const promUpload = new Promise((resolve, reject) => {
//     fileMD5(file, (md5) => {
//       if (!md5) {
//         console.error('cal file md5 failed!')
//         reject('cal file md5 failed!')
//       }
//       const data = new FormData()
//       data.append('file', file)
//       data.append('name', file.name)
//       data.append('md5', md5)
//       data.append('contentType', file.type)
//       data.append('group', group)
//       data.append('module', module)
//       data.append('fileLength', file.size)
//       data.append('mode', uploadMode)

//       request({
//         url: `/admin/v1/common/upload/${type}`,
//         method: 'post',
//         config: {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//           },
//         },
//         data,
//       }).then((res) => {
//         console.info('------promUpload------>', res)
//         if (res && res.code === 1) {
//           res.data.fileName = file.name
//           res.data.fileMd5 = md5
//           res.data.uid = file.uid
//         }
//         resolve(res)
//       }).catch((err) => {
//         reject(err)
//       })
//     })
//   })
//   promUpload.abort = () => {}
//   return promUpload
// }

/**
 * 附带进度条上传组件
 *
 * @param {*} file 上传的文件对象
 * @param {*} uploadMode 上传文件模式
 * @param {Function} handleProcess 上传进行时回调
 * @param {Function} 取消文件上传回调
 * PRIVATE 私有模式，将返回bucket与objectName，业务方需要使用oss sdk进行下载
 * GRANT_READ_WITH_EXPIRATION：限时授权模式，在有效期内可以读取文件
 * GRANT_READ 长期授权模式，可以长期使用
 * VPC_READ VPC内部模式，可以在vpc内部直接使用
 * PUBLIC_READ 公开模式，可以在公网直接读取
 * PUBLIC_READ_WITH_CDN CDN模式，将文件推送至公网CDN
 */
// function doUploadFileWithPercent({
//   file,
//   group = 'test_group',
//   module = 'test_module',
//   uploadMode = 'PUBLIC_READ_WITH_CDN',
//   handleProcess = () => {},
//   handleCancel = () => {},
//   uploadType = '',
//   chunkSize = 0,
// }) {
//   uploadType = uploadType || 'file'
//   return new Promise((resolve, reject) => {
//     fileMD5(file, (md5) => {
//       if (!md5) {
//         console.error('cal file md5 failed!')
//         reject('cal file md5 failed!')
//       }
//       chunkSize *= 1024 // 1MB一片
//       let uploaded = 0
//       // 首次上传100KB+1B大小的分片，去获取已上传的部分
//       const countPart = Math.ceil((file.size - 102401) / chunkSize) + 1 // 总片数
//       const getChunkInfo = (fileItem, currentPart, size) => {
//         const start = currentPart === 0 ? 0 : (currentPart - 1) * size + 102401
//         const end = currentPart === 0 ? 102401 : Math.min(fileItem.size, start + size)
//         const chunk = fileItem.data ? fileItem.data.slice(start, end) : fileItem.slice(start, end)
//         return { start, end, chunk }
//       }
//       // 针对每个文件进行chunk处理
//       const readChunk = () => {
//         // 针对单个文件进行chunk上传
//         if (chunkSize) {
//           const { chunk } = getChunkInfo(file, 0, chunkSize)
//           uploadChunk({ chunk, currentPart: 1, countPart })
//         }
//         if (!chunkSize) {
//           uploadChunk({ chunk: file })
//         }
//       }
//       const uploadChunk = (chunkInfo) => {
//         const data = new FormData()
//         const chunkLength = chunkInfo.chunk.size
//         data.append('file', chunkInfo.chunk, file.name)
//         data.append('name', file.name)
//         data.append('md5', md5)
//         data.append('contentType', file.type)
//         data.append('group', group)
//         data.append('module', module)
//         data.append('fileLength', file.size)
//         data.append('mode', uploadMode)
//         if (chunkSize) {
//           data.append('currentPart', chunkInfo.currentPart)
//           data.append('countPart', chunkInfo.countPart)
//         }
//         request({
//           url: `/admin/v1/common/upload/${uploadType}`,
//           method: 'post',
//           config: {
//             headers: {
//               'Content-Type': 'multipart/form-data',
//             },
//           },
//           // 上传进行时回调,返回上传进度
//           onUploadProgress: (event) => {
//             file.percent = (((uploaded + (event.loaded / event.total) * chunkLength) / file.size) * 100).toFixed(2)
//             handleProcess(file)
//           },
//           // 取消文件上传
//           cancelToken: new axios.CancelToken((c) => {
//             handleCancel(c)
//           }),
//           timeout: 0,
//           data,
//         })
//           .then((res) => {
//             if (
//               res &&
//               res.code === 1 &&
//               (!chunkSize || (chunkSize && res.data.hasUploaded))
//             ) {
//               res.data.fileName = file.name
//               res.data.fileMd5 = md5
//               res.data.uid = file.uid
//               return resolve(res)
//             }
//             uploaded = res.data.uploadedSize
//             file.percent = ((res.data.uploadedSize / file.size) * 100).toFixed(2)
//             handleProcess(file)
//             if (res.data.uploadedParts <= chunkInfo.countPart) {
//               const { chunk } = getChunkInfo(
//                 file,
//                 res.data.uploadedParts,
//                 chunkSize,
//               )
//               uploadChunk({
//                 chunk,
//                 currentPart: res.data.uploadedParts + 1,
//                 countPart: chunkInfo.countPart,
//               })
//             }
//           })
//           .catch((err) => {
//             reject(err)
//           })
//       }
//       readChunk()
//     })
//   })
// }

function doUploadFileWithPercentNotShard({
  file,
  group,
  code,
  handleProcess = () => {},
  handleCancel = () => {},
}) {
  console.info('===in doUploadFileWithPercentNotShard===', group)
  const data = new FormData()
  data.append('file', file)
  data.append('group', group)
  data.append('code', code)
  return new Promise((resolve, reject) => {
    request({
      url: '/admin/v1/vehicle/fs/standard/file/upload',
      method: 'post',
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      // 上传进行时回调,返回上传进度
      onUploadProgress: ({ loaded, total }) => {
        file.percent = (loaded / total * 100).toFixed(2)
        handleProcess(file)
      },
      // 取消文件上传
      cancelToken: new axios.CancelToken((c) => {
        handleCancel(c)
      }),
      timeout: 0,
      data,
    })
      .then((res) => {
        if (res && res.code === 1) {
          res.data.fileName = file.name
          res.data.uid = file.uid
          return resolve(res)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// function privateUpload(file) {
//   console.info('===in privateUpload===')
//   if (file.data && (typeof file.data === 'string')) {
//     file = parseStrToFile(file.data, file.type)
//   }
//   return doUploadFile(file, 'private', 'file', 'VPC_READ', this.uploadType)
// }

// function publicUpload(file, type) {
//   console.info('===in publicUpload===')
//   const paramType = type || ''
//   const types = paramType ? type : this.uploadType
//   if (file.data && (typeof file.data === 'string')) {
//     file = parseStrToFile(file.data, file.type)
//   }
//   return doUploadFile(file, 'public', 'image', 'PUBLIC_READ_WITH_CDN', types)
// }

// function privateUploadWithPercent(params, uploadType = this.uploadType) {
//   console.info('===in privateUploadWithPercent===', params)
//   return doUploadFileWithPercent({
//     ...params,
//     group: 'private',
//     module: 'file',
//     uploadMode: 'VPC_READ',
//     uploadType,
//   })
// }

// function publicUploadWithPercent(params, uploadType = this.uploadType) {
//   console.info('===in publicUploadWithPercent===', params)
//   return doUploadFileWithPercent({
//     ...params,
//     group: 'public',
//     module: 'file',
//     uploadMode: 'PUBLIC_READ_WITH_CDN',
//     uploadType,
//   })
// }
function uploadFileNotShared(params) {
  console.info('===in uploadFileNotShared===', params)
  return doUploadFileWithPercentNotShard({
    ...params,
  })
}

/** ========== utils ========== */
// function parseStrToFile(str, fileType) {
//   let idx = str.length
//   const fix = fileType.match(/\/?([^/]+)$/)[1]
//   const u8Arr = new Uint8Array(str.length)
//   while (idx--) {
//     u8Arr[idx] = str.charCodeAt(idx)
//   }
//   const name = Math.random().toString().slice(2).concat(`.${fix}`)
//   return new window.File([u8Arr], name, {
//     type: fileType,
//     lastModified: new Date(),
//   })
// }

// function fileMD5(file, callback) {
//   if (file.data && (typeof file.data === 'string')) {
//     const spark = new SparkMD5.ArrayBuffer()
//     spark.append(str2Buffer(file.data))
//     return callback(spark.end())
//   }
//   return getFileMd5(file, callback)
// }

// function getFileMd5(file, callback) {
//   const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
//   const chunkSize = 2097152 // Read in chunks of 2MB
//   const chunks = Math.ceil(file.size / chunkSize)
//   let currentChunk = 0
//   const spark = new SparkMD5.ArrayBuffer()
//   const fileReader = new FileReader()

//   fileReader.onload = function (e) {
//     spark.append(e.target.result) // Append array buffer
//     currentChunk++
//     if (currentChunk < chunks) {
//       return loadNext()
//     }
//     const md5 = spark.end()
//     callback(md5)
//   }
//   fileReader.onerror = function () {
//     console.warn('oops, something went wrong.')
//     callback(null)
//   }
//   function loadNext() {
//     const start = currentChunk * chunkSize
//     const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
//     fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
//   }
//   loadNext()
// }

// function str2Buffer(str) {
//   const buffer = new ArrayBuffer(str.length * 2)
//   const bufView = new Uint16Array(buffer)
//   for (let i = 0, strLen = str.length; i < strLen; i++) {
//     bufView[i] = str.charCodeAt(i)
//   }
//   return buffer
// }
/** ========== utils ========== */

export {
  // privateUpload,
  // publicUpload,
  // privateUploadWithPercent,
  // publicUploadWithPercent,
  uploadFileNotShared,
}
